// Audios
import offlineOrderAudio from '../assets/sounds/deactivated_alarm.mp3';
import newOrderAudio from '../assets/sounds/audio2.mp3';
import canceledOrderAudio from '../assets/sounds/the-calling.mp3';
import rtNotificationSound from '../assets/sounds/RtSound.mp3';
import orderMgmtNewOrderAudio from '../assets/sounds/rappitonecorto.mp3';
import turboOrderAudio from '../assets/sounds/turbo_order_sound.mp3';
import { setTimeout } from 'timers';
import { autoAcceptService } from 'features/settings-page/auto-accept';

// Audio types.
const CANCELED_ORDER_AUDIO = 'CANCELED_ORDER_AUDIO';
const OFFLINE_AUDIO = 'OFFLINE_AUDIO';
const NEW_ORDER_AUDIO = 'NEW_ORDER_AUDIO';
const RT_NOTIFICATION_SOUND = 'RT_NOTIFICATION_SOUND';
const ORDER_MGMT_NEW_ORDER = 'ORDER_MGMT_NEW_ORDER';
const TURBO_ORDER_SOUND = 'TURBO_ORDER_SOUND';

/**
 * It is the audio instance.
 */
let audio;
/**
 *  Represents the audio currently being played.
 */
let audioBeingPlayed;

const _playSound = (audioPlayed, assetUrl, hasLoop = true) => {
  if (audio) {
    audio.pause();
  }
  audio = new Audio(assetUrl);
  audio.loop = hasLoop;
  audio
    .play()
    .then(() => {
      audioBeingPlayed = audioPlayed;
    })
    .catch(error => {
      console.error("Can't play audio:", error);
    });
};

const _pauseSoundWhenHaveAutoAccept = () => {
  if (autoAcceptService.isEnabled()) {
    setTimeout(() => {
      pauseAudio();
    }, 4_000);
  }
};

const getAudioBeingPlayed = () => {
  return audioBeingPlayed;
};

const playAudio = () => {
  try {
    audio.play();
  } catch (ex) {
    console.error(ex.message);
  }
};

const playOfflineAudio = () => {
  _playSound(OFFLINE_AUDIO, offlineOrderAudio);
};

const playCanceledOrderAudio = () => {
  _playSound(CANCELED_ORDER_AUDIO, canceledOrderAudio);
};

const playNewOrderAudio = () => {
  _playSound(NEW_ORDER_AUDIO, newOrderAudio);
  _pauseSoundWhenHaveAutoAccept();
};

const playNotificationRTSound = () => {
  _playSound(RT_NOTIFICATION_SOUND, rtNotificationSound, false);
};

const pauseAudio = () => {
  if (!audio) {
    return;
  }
  audioBeingPlayed = null;
  audio.pause();
  audio = null;
};

const playOrderMgmtNewOrderSound = () => {
  _playSound(ORDER_MGMT_NEW_ORDER, orderMgmtNewOrderAudio, false);
};

const playTurboOrderSound = () => {
  _playSound(TURBO_ORDER_SOUND, turboOrderAudio);
  _pauseSoundWhenHaveAutoAccept();
};

export default {
  getAudioBeingPlayed,
  playCanceledOrderAudio,
  playNewOrderAudio,
  playNotificationRTSound,
  playOfflineAudio,
  pauseAudio,
  playOrderMgmtNewOrderSound,
  playTurboOrderSound,
};
